import React from 'react';
import { identity } from 'rxjs';
import { shareReplay, map, filter } from 'rxjs/operators';
import { FormBaseLayout } from '../../components/form/FormBaseLayout';
import { XbpmFieldType } from '../../models';
import * as R from 'ramda';
var toUpperCase = function (x) { return typeof x === 'string' ? x.toUpperCase() : null; };
var toUIElementsFactoryMap = R.pipe(R.toPairs, R.map(function (_a) {
    var k = _a[0], v = _a[1];
    return [toUpperCase(k), v];
}), function (pairs) { return new Map(pairs); });
var unknownElementFactory = function (kind, code) { return function () {
    console.error('Unknown element:', kind, code);
    return (null);
}; };
var getNodeKey = function (element) { return [element.parentId, element.id].filter(function (x) { return !!x; }).join('>'); };
var FormRenderer = /** @class */ (function () {
    function FormRenderer(context, controls, containers, baseLayout) {
        var _this = this;
        this.context = context;
        this.baseLayout = baseLayout;
        this.nodes = new Map();
        this.selectDefinition$ = function (id, mapDef) {
            var def$ = _this.context.getElementDefinition$(id);
            var mapDefinition = mapDef ? map(mapDef) : identity;
            return def$.pipe(filter(R.identity), mapDefinition, shareReplay(1));
        };
        // render root block
        this.renderRoot = function (onEvent) {
            var node = _this.renderElement(_this.context.formDefinition, onEvent);
            return _this.baseLayout ? _this.baseLayout(node, _this.context) : React.createElement(FormBaseLayout, null, node);
        };
        // render child element
        this.renderChild = function (def, onEvent, mapDef) {
            return _this.renderElement(def, onEvent, mapDef);
        };
        // search form formula element definition
        this.findFormulaDefinition = function (id) { return !!id ? _this.context.findFormulaDefinition(id) : null; };
        this.controls = toUIElementsFactoryMap(controls);
        this.containers = toUIElementsFactoryMap(containers);
    }
    // render element
    FormRenderer.prototype.renderElement = function (element, onEvent, mapDef) {
        var nodeKey = getNodeKey(element);
        // // check rendered element
        var node = this.nodes.get(nodeKey);
        if (node) {
            return node;
        }
        // element observers
        var def$ = this.selectDefinition$(element.id, mapDef);
        var error$ = this.context.elementError$(element.id);
        // properties
        var id = element.id, kind = element.kind, code = element.code, frontOptions = element.frontOptions;
        var props = { key: id, def$: def$, error$: error$, initialDef: element, onEvent: onEvent, renderService: this, mapDef: mapDef };
        var $kind = toUpperCase(kind) === XbpmFieldType.CUSTOM
            ? toUpperCase(frontOptions.customKind)
            : toUpperCase(kind);
        // render element
        var render = this.controls.get($kind) || this.containers.get($kind) || unknownElementFactory($kind, code);
        node = render(props);
        this.nodes.set(nodeKey, node);
        return node;
    };
    //
    FormRenderer.prototype.onElementDestroy = function (element) {
        if (element) {
            this.nodes.delete(getNodeKey(element));
            this.context.onElementDestroy(element);
        }
    };
    FormRenderer.prototype.clean = function () {
        this.nodes.clear();
    };
    return FormRenderer;
}());
export { FormRenderer };
//# sourceMappingURL=form-renderer.js.map